import { useState, useEffect } from "react";
import { FaHeart, FaVideo, FaCommentDots } from "react-icons/fa";
import { FaHeartCircleCheck } from "react-icons/fa6";
import { MdPhoto } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useParams, useNavigate } from "react-router-dom";
import {
  OtherProfileDetails, GetOtherProfilePosts, FollowUser, UnfollowUser, CheckUserFollow
} from "../../services/api";
import { getMediaUrl, getProfileImage } from "../../utils/helpers";
import PhotoViewer from "../../components/Profile/PhotoViewer";
import { OtherStory } from "./OtherStory";
import ReportProfile from "../../components/Profile/ReportProfile";
import PrivateCallModal from "../../components/PrivateCallModal";

export default function Profile() {

  const { userId } = useParams();
  const navigate = useNavigate();

  const [openReport, setOpenReport] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerImages, setViewerImages] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [followingUser, setFollowingUser] = useState(false);

  const [profileUrl, setProfileUrl] = useState("");
  const [userName, setUserName] = useState("");
  const [status, setStatus] = useState("");
  const [country, setCountry] = useState("");
  const [countryFlag, setCountryFlag] = useState("");
  const [bio, setBio] = useState("");
  const [postCount, setPostCount] = useState(0);
  const [followerCount, setFollowerCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);

  const [postData, setPostData] = useState("");

  const [privateCall, setPrivateCall] = useState(false);
  const [hostCallData, setHostCallData] = useState([]);

  useEffect(() => {
    fetchDetails();
    fetchUserFollow();
    fetchPosts();
  }, []);

  const fetchDetails = () => {
    OtherProfileDetails(userId)
      .then((res) => {

        setHostCallData(res.data);

        setProfileUrl(getMediaUrl(res?.data?.ppImageURL));
        setUserName(res?.data?.name);
        setStatus(res?.data?.status);
        setCountry(res?.data?.countryId?.name);
        setCountryFlag(res?.data?.countryId?.flag);
        setBio(res?.data?.about);
        setFollowerCount(res?.data?.followerCount);
        setFollowingCount(res?.data?.followingCount);
      })
      .catch((err) => {
        console.log(err)
      });
  }

  const fetchUserFollow = () => {
    CheckUserFollow(userId)
      .then((res) => {
        setFollowingUser(res?.data);
      })
      .catch((err) => {
        console.log(err)
      });
  }

  const fetchPosts = () => {
    GetOtherProfilePosts(userId)
      .then((res) => {
        setPostData(res?.data);
        setPostCount(res?.data?.length);
      })
      .catch((err) => {
        console.log(err)
      });
  }

  const OnStartVideoChatClick = () => {
    setPrivateCall(true);
  }

  const OnFollowClick = () => {

    if (followingUser) {
      UnfollowUser(userId)
        .then((res) => {
          setFollowingUser(false);
        })
        .catch((err) => {
          console.log(err)
        });
    }
    else {
      FollowUser(userId)
        .then((res) => {
          setFollowingUser(true);
        })
        .catch((err) => {
          console.log(err)
        });
    }
  }

  const OnMessageClick = () => {
    console.log("Message User >> ");

    navigate("/messages", {
      state: {
        openChatWith: userId,
      },
    });
  }

  return (
    <div className="min-h-screen bg-black text-white px-4 md:px-16 pt-24 relative">

      {/* ✅ THREE DOTS BUTTON (FIXED & ALWAYS VISIBLE) */}
      <button
        onClick={() => setOpenReport(true)}
        className="absolute top-24 right-6 text-white text-2xl z-50"
      >
        <BsThreeDots />
      </button>

      {/* ✅ PROFILE SECTION */}
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8">

        {/* PROFILE IMAGE */}
        <div className="relative">
          <div className="w-40 h-40 rounded-full bg-gradient-to-tr from-red-500 to-red-700 p-1">
            <img
              src={getProfileImage(profileUrl)}
              alt="profile"
              className="w-full h-full rounded-full object-cover"
              onClick={() => {
                setActiveIndex(0);
                setViewerOpen(true);
                setViewerImages([
                  {
                    id: 12345,
                    url: getProfileImage(profileUrl)
                  }
                ]);
              }}
            />
          </div>

          {/* <span className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-red-700 text-xs px-3 py-1 rounded-full font-semibold">
            LIVE
          </span> */}
        </div>

        {/* PROFILE DETAILS */}
        <div className="flex-1 w-full">
          <h1 className="text-2xl md:text-3xl font-bold">
            {userName}
          </h1>

          <div className="flex items-center gap-3 mt-2 text-sm text-gray-400">
            {country}
            <img
              src={countryFlag}
              alt="flag"
              className="w-6 h-4 rounded-sm"
            />
            <span
              className={`flex items-center gap-1 ${status === "online" ? "text-green-400" : "text-gray-400"}`}
            >
              <span
                className={`w-2 h-2 rounded-full ${status === "online" ? "bg-green-400" : "bg-gray-400"}`}
              ></span>

              {status === "online" ? "Available" : "Offline"}
            </span>
          </div>

          <div className="flex items-center gap-3 mt-2 text-sm text-gray-400">
            {bio}
          </div>

          {/* STATS */}
          <div className="flex gap-10 mt-6">
            <div className="text-center">
              <h2 className="text-xl font-bold">{postCount}</h2>
              <p className="text-sm text-gray-400">Post</p>
            </div>
            <div className="text-center">
              <h2 className="text-xl font-bold">{followerCount}</h2>
              <p className="text-sm text-gray-400">Follower</p>
            </div>
            <div className="text-center">
              <h2 className="text-xl font-bold">{followingCount}</h2>
              <p className="text-sm text-gray-400">Following</p>
            </div>
          </div>

          {/* BUTTONS */}
          <div className="flex flex-wrap gap-4 mt-6">
            <button
              onClick={OnStartVideoChatClick}
              className="flex items-center gap-2 bg-red-500 transition px-6 py-3 rounded-full font-semibold">
              <FaVideo />
              Start Video Chat
            </button>

            <button
              onClick={OnFollowClick}
              className={`flex items-center gap-2 ${followingUser ? "bg-red-500" : "bg-gray-800"} transition px-6 py-3 rounded-full`}>
              {followingUser ? <FaHeartCircleCheck /> : <FaHeart />}
              {followingUser ? "Followed" : "Follow"}
            </button>

            <button
              onClick={OnMessageClick}
              className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 transition px-6 py-3 rounded-full">
              <FaCommentDots />
              Message
            </button>
          </div>
        </div>
      </div>

      <OtherStory userId={userId} />

      <div className="flex flex-wrap gap-2 items-center text-lg font-bold mt-10">
        <MdPhoto size={30} />
        Posts {postData.length}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 py-10">

        {postData && postData?.map((posts, index) => (
          <div
            key={posts._id}
            className="relative bg-gray-900 cursor-pointer aspect-square overflow-hidden"
            onClick={() => {
              setActiveIndex(index);
              setViewerOpen(true);
              setViewerImages(
                postData?.map(post => ({
                  id: post._id,
                  url: `${process.env.REACT_APP_MEDIA_BASE_URL}${post.url}`
                })) || []
              );
            }}
          >
            <img
              src={`${process.env.REACT_APP_MEDIA_BASE_URL}${posts.url}`}
              alt="posts"
              className="w-full h-full object-cover"
            />
          </div>
        ))}

        {/* Viewer */}
        {viewerOpen && (
          <PhotoViewer
            images={viewerImages}
            currentIndex={activeIndex}
            onClose={() => setViewerOpen(false)}
            onPrev={() => setActiveIndex((i) => i - 1)}
            onNext={() => setActiveIndex((i) => i + 1)}
          />
        )}

      </div>

      {
        openReport && <ReportProfile userId={userId} onClose={() => setOpenReport(false)} />
      }

      {privateCall &&
        <PrivateCallModal
          onClose={() => setPrivateCall(false)}
          host={hostCallData}
        />
      }

    </div>
  );
}